import Factory from '../utils/factory'

export default Factory({
  image: null,
  data: [],
  conditions: {
    if: [],
    ifnot: [],
  },
})
